import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";

const Thankyou = () => {
  const intervalRef = useRef();
  const location = useLocation();
  const history = useHistory();
  const [status, setStatus] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location?.search || "");
    // Everything but an explicit status=false is a completed payment: the
    // failure path is the only one that says so, and a bare /thank-you (which
    // is what older links produce) means success.
    const paid = params.get("status") !== "false";
    setStatus(paid);

    intervalRef.current = setInterval(() => {
      history.push(paid ? "/authorization" : "/");
    }, 1000);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [location]);

  return (
    <div
      style={{ height: "calc(100 * var(--vh))" }}
      className="d-flex text-center flex-column justify-content-center"
    >
      {status ? (
        <>
          <h1 className="display-1 text-success">Payment Successful</h1>
          <p className="text-muted">Kindly check your inbox for your licence</p>
        </>
      ) : (
        <>
          <h1 className="display-1 text-danger">Payment Failed</h1>
          <p className="text-muted">Kindly retry after some time.</p>
        </>
      )}
    </div>
  );
};

export default Thankyou;
